<div class="card" (click)="cardClicked.emit()" *ngIf="company$ | ngrxPush as company">
    <div class="card-body p-2 w-full">
        <div class="flex gap-6 full">
            <app-company-avatar
                [enableEditLogo]="enableEditLogo"
                [businessPartnerId]="company.companyId"
                [mode]="CompanyMode.CUSTOMER"
                avatarClasses="w-[64px]"
            ></app-company-avatar>

            <div class="flex mt-2 w-full">
                <div class="w-full">
                    <h4 class="mb-0 break-word text-[20px]">{{ company.name }}</h4>

                    <div class="text-sm flex items-center gap-2 relative">
                        {{ company.companyNumber }}
                        <button
                            (mouseenter)="showCompanyNumberToolTip()"
                            (mouseleave)="hideTooltip()"
                            (click)="enableEditLogo && copyCompanyNumber(company)"
                            class=""
                        >
                            <iota-icon *ngIf="!showCheckedIcon && enableEditLogo" icon="link"></iota-icon>
                            <iota-icon
                                *ngIf="showCheckedIcon && enableEditLogo"
                                icon="check-circle"
                                size="1"
                                class="bg-primary rounded-full text-white"
                            ></iota-icon>
                            <span
                                *ngIf="enableEditLogo && showTooltip"
                                class="whitespace-nowrap absolute -top-6 left-16 rounded-lg px-1 py-0.5 text-xs bg-neutral text-base-100"
                            >
                                {{ tooltipText }}
                            </span>
                        </button>
                    </div>

                    <div *ngIf="(roleChips$ | ngrxPush)?.length > 0" class="flex flex-row gap-2">
                        <div *ngFor="let chip of roleChips$ | ngrxPush" [class]="'badge badge-' + chip.color">{{ chip.name }}</div>
                    </div>
                </div>
            </div>
        </div>

        <table class="table table-compact" *ngIf="displayAdditionalInfo">
            <tbody>
                <tr *ngIf="companyMode === CompanyMode.CUSTOMER">
                    <th i18n>Employees:</th>
                    <td>
                        {{ company.employeesCount || 0 }}
                    </td>
                </tr>

                <tr *ngIf="companyMode === CompanyMode.PARTNER">
                    <th i18n>Products:</th>
                    <td *ngIf="loadingProducts(); else showProducts">
                        <app-dots-loading-animation></app-dots-loading-animation>
                    </td>
                    <ng-template #showProducts>
                        <td>{{ products().length || 0 }}</td>
                    </ng-template>
                </tr>

                <tr *ngIf="address$ | ngrxPush as address">
                    <th i18n>Address:</th>
                    <td class="break-words whitespace-pre-wrap">{{ address }}</td>
                </tr>

                <tr *ngIf="naceCodeDescription$ | ngrxPush as naceCodeDescription">
                    <th i18n>Industry:</th>
                    <td class="break-words whitespace-pre-wrap">{{ company.naceCode }} - {{ naceCodeDescription }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
